import { render } from "./WebEmptyView.vue?vue&type=template&id=13623e2b&scoped=true"
import script from "./WebEmptyView.vue?vue&type=script&lang=js"
export * from "./WebEmptyView.vue?vue&type=script&lang=js"

import "./WebEmptyView.vue?vue&type=style&index=0&id=13623e2b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13623e2b"]])

export default __exports__